"use strict";
exports.__esModule = true;
var Flickity = require("flickity");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var DOMScript_1 = require("@/scripts/utils/DOMScript");
var TWSlider = /** @class */ (function () {
    function TWSlider(sliderSelector, $sliderWrap, activationLimit, flikityOptions) {
        this.sliderSelector = sliderSelector;
        this.$sliderWrap = $sliderWrap;
        this.activationLimit = activationLimit;
        this.flikityOptions = flikityOptions;
        this.flikity = null;
        this.childernCount = null;
        this.isUnderLimit = false;
        this.initSlider();
    }
    TWSlider.prototype.initSlider = function () {
        var _this = this;
        var _a, _b, _c, _d;
        this.childernCount = (_c = (_b = (_a = this.$sliderWrap) === null || _a === void 0 ? void 0 : _a.$$(this.flikityOptions.cellSelector)) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0;
        if (this.childernCount <= 1) {
            (_d = this.$sliderWrap) === null || _d === void 0 ? void 0 : _d.$addClass('--no-active-slider');
            return this;
        }
        if (this.activationLimit && this.childernCount < this.activationLimit)
            this.isUnderLimit = true;
        this.flikity = new Flickity(this.$sliderWrap, this.flikityOptions);
        this.disableBarba();
        (0, DOMScript_1.getRefreshEvent$)().pipe((0, operators_1.take)(1)).subscribe(function () { var _a; return (_a = _this.flikity) === null || _a === void 0 ? void 0 : _a.destroy(); });
        return this;
    };
    TWSlider.prototype.disableBarba = function () {
        var _this = this;
        var _a, _b, _c;
        (_a = this.flikity) === null || _a === void 0 ? void 0 : _a.on("dragStart", function () {
            window.twEvents.disableBarba = true;
        });
        (_b = this.flikity) === null || _b === void 0 ? void 0 : _b.on("dragEnd", function (event) {
            var $target = event === null || event === void 0 ? void 0 : event.target;
            if (!$target.closest(_this.sliderSelector))
                window.twEvents.disableBarba = false;
        });
        var clicks$ = Array.from((_c = this.$sliderWrap) === null || _c === void 0 ? void 0 : _c.$$("a"))
            .map(function ($el) { return (0, rxjs_1.fromEvent)($el, "click"); });
        rxjs_1.merge.apply(void 0, clicks$).subscribe(function (e) {
            if (window.twEvents.disableBarba) {
                e.stopPropagation();
                e.preventDefault();
                window.twEvents.disableBarba = false;
            }
        });
    };
    TWSlider.prototype.destroy = function () {
        var _a;
        (_a = this.flikity) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    return TWSlider;
}());
exports["default"] = TWSlider;
